import type {Context} from '../types';

export default (context: Context) => {
  const {jsonNode} = context.node;
  const {data = {}} = jsonNode;

  return {
    needed: jsonNode.type === 'Link' && Boolean(data.val),
    logData: {
      msg: 'Delete corrupt expression data from links',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      // Fix link
      const linkExprValue = data.val?.link?.val?.value;
      if (linkExprValue && !data.link) {
        data.link = linkExprValue;
      }

      // Delete corrupt data
      // eslint-disable-next-line webflow/no-delete
      delete data.val;

      if (data.type) {
        // eslint-disable-next-line webflow/no-delete
        delete data.type;
      }
    },
  };
};
